import { connect } from "react-redux"
import { activateBrukerRequest } from "../../actions/LoginActions"
import { addFlashMessage } from "../../actions/FlashMessagesAction"
import ResetPassword from '../../components/account/ResetPassword'

export default connect(null, { updateForgotPasswordRequest: activateBrukerRequest, addFlashMessage })(ResetPassword)